import { render, staticRenderFns } from "./StudentCreatorTable.vue?vue&type=template&id=9fa086c6"
import script from "./StudentCreatorTable.vue?vue&type=script&lang=js"
export * from "./StudentCreatorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports